import React, { useState } from 'react';
import { ListMusic } from 'lucide-react';
import { VideoClip } from './VideoClip';
import { FONT, MONO } from './ui';

// Plays the two Christmas broadcasts back-to-back (1957 → 2015) for the TRAP comparison.
export const QueenCompare = ({ videos, t, L, pron, pronNote, pronLabels, labDialect }) => {
  const [tokens, setTokens] = useState(videos.map(() => 0));
  const [step, setStep] = useState(-1);
  const play = (i) => { setStep(i); setTokens((p) => p.map((x, j) => (j === i ? x + 1 : x))); };
  const ended = (i) => { if (step === i) { if (i + 1 < videos.length) play(i + 1); else setStep(-1); } };
  return (
    <div className="mt-10 rounded-3xl bg-slate-900 p-6 lg:p-8" data-testid="queen-videos">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-5">
        <p className="text-white font-bold" style={FONT}>{t.compareBroadcasts}</p>
        <button onClick={() => play(0)} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-amber-300 hover:bg-amber-200 text-slate-950 text-sm font-bold transition-colors" data-testid="queen-play-sequence">
          <ListMusic className="w-4 h-4" />{t.playSequence}
        </button>
      </div>
      {step >= 0 && <p className="mb-4 text-xs text-amber-200" style={MONO} data-testid="queen-sequence-status">{t.nowPlaying} {step + 1}/{videos.length} · {videos[step].label}</p>}
      <div className="grid md:grid-cols-2 gap-6">
        {videos.map((v, i) => (
          <div key={v.id} className={`rounded-2xl transition-shadow ${step === i ? 'ring-2 ring-amber-300 ring-offset-4 ring-offset-slate-900' : ''}`}>
            <VideoClip v={v} t={t} L={L} playToken={tokens[i]} onEnded={() => ended(i)} onManual={() => setStep(-1)} pron={pron} pronNote={pronNote} pronLabels={pronLabels} labDialect={labDialect} />
          </div>
        ))}
      </div>
    </div>
  );
};
